import PropertyRepository from "./PropertyRepository";
import MediaRepository from "./MediaRepository";
import AddressRepository from "./AddressRepository";
import ProvinceRepository from "./ProvinceRepository";
import ImportRepository from "./ImportRepository";
import MailRepository from "./MailRepository";
import SecurityRepository from "./SecurityRepository";

const repositories = {
  property: PropertyRepository,
  media: MediaRepository,
  address: AddressRepository,
  province: ProvinceRepository,
  import: ImportRepository,
  mail: MailRepository,
  security: SecurityRepository,
};

export const RepositoryFactory = {
  get: (name) => repositories[name],
  bulkGet: (names) =>
    names
      .filter((name) => Object.keys(repositories).includes(name))
      .map((repositoryName) => repositories[repositoryName]),
};
